export default "__VITE_ASSET__LjaBA1xs__"